/**
 * Utilities for parsing AG Grid column field strings and constructing
 * network-qualified field paths used by field comments and AI lookups.
 *
 * Column fields follow the pattern "{planId}" or "{planId}.{networkName}".
 * Qualified field paths use "::" as separator: "benefitKey::networkName".
 */

export interface ParsedPlanField {
  planId: string;
  network?: string;
}

/**
 * Parses plan ID and optional network name from an AG Grid column field.
 * Column fields follow the pattern "{planId}" or "{planId}.{networkName}".
 */
export const parsePlanField = (field?: string): ParsedPlanField | undefined => {
  if (!field) return undefined;
  const [planId, network] = field.split(".");
  if (!planId) return undefined;
  return { planId, network: network || undefined };
};

/**
 * Qualifies a benefitKey with a network name when present.
 * e.g. ("deductible", "inNetwork") → "deductible::inNetwork"
 */
export const qualifyFieldPath = (
  benefitKey: string,
  network?: string,
): string => (network ? `${benefitKey}::${network}` : benefitKey);
